import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { updateQuantityInput } from '../Actions/QuantityInput.action';

const QuantityInput = ({ quantityFieldId, variantId, placeholder, className = "product-card__purchase-quantity", value = null, min = 0, max = 999, maxLength = 3, includeInMultiPurchase = true }) => {
    const dispatch = useDispatch();
    const [highLight, setHighLight] = useState(false);

    const quantityField = useSelector(state => state.quantityInput.quantityFields[quantityFieldId]);
    const cartRows = useSelector(state => state.cart.orderRows)
    const isInCart = cartRows.find(x => x.articleNumber === variantId);

    const handleOnChange = (e) => {
        dispatch(updateQuantityInput({ quantityFieldId, variantId, value: +e.target.value, includeInMultiPurchase }))
    }

    const handleOnKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const article = e.target.closest('article');
            if (article) {
                var buyButton = article.querySelector('.buy-button');
                if (buyButton) {
                    buyButton.click();
                }
            }
        }
        else if (e.key === 'Tab' && e.shiftKey) {
            const article = e.target.closest('article');
            if (article) {
                var nextArticle = article.previousElementSibling;
                if (nextArticle && nextArticle.tagName.toLowerCase() === 'article') {
                    e.preventDefault();
                    var wrapper = nextArticle.querySelector('.product-list-item__wrapper');
                    wrapper.classList.remove('closed');

                    const numberInputs = document.querySelectorAll('input[type="number"]');
                    const inputsArray = Array.from(numberInputs);
                    const currentIndex = inputsArray.indexOf(e.target);

                    const nextElement = inputsArray[currentIndex - 1] || null;
                    nextElement.focus();
                }
            }
        }
    }

    useEffect(() => {
        dispatch(updateQuantityInput({ quantityFieldId, variantId, value }))
    }, [quantityFieldId, variantId])

    useEffect(() => {
        if (quantityField?.highlight) {
            setHighLight(true)
            setTimeout(() => setHighLight(false), 200);
        } else {
            setHighLight(false);
        }
    }, [quantityField?.highlight])

    return (
        <input
            onChange={handleOnChange}
            onKeyDown={handleOnKeyDown}
            onWheel={(e) => e.target.blur()}
            data-is-in-cart={isInCart ? true : false}
            id={quantityFieldId}
            data-variant-id={variantId}
            type="number"
            placeholder={placeholder}
            data-buy-quantity-input
            value={quantityField?.value ?? ''}
            min={min}
            max={max}
            maxLength={maxLength}
            className={`${className} ${highLight ? 'no-quantity' : ''}`}
        />
    )
}

export default QuantityInput